import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { StatusDateEnum } from 'src/app/enum/article-task-enums';
import { ArticleTaskTableModel } from 'src/app/models/tables/others/article-task-table.model';

@Component({
  selector: 'app-pending-article-task',
  templateUrl: './pending-article-task.component.html',
  styleUrls: ['./pending-article-task.component.scss'],
  standalone: false
})
export class PendingArticleTaskComponent implements OnInit {
  public config = inject(DynamicDialogConfig);
  private readonly router = inject(Router);
  private readonly ref = inject(DynamicDialogRef, { optional: true });

  listArticleTasks: ArticleTaskTableModel[] = [];
  suscription: Subscription;
  visibleButton: boolean = false;
  scheduleStatus = StatusDateEnum.programada;
  defeatedStatus = StatusDateEnum.vencida;
  atTimeStatus = StatusDateEnum.aTiempo;

  ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.suscription = input$?.subscribe((inputs: any) => {
      this.listArticleTasks = inputs.listArticleTasks;
    });
    this.visibleButton = this.router.url.includes('/article-task/') ? false : true;
  }

  executeTask(articleTask: ArticleTaskTableModel) {
    if (this.ref) this.ref.close();
    this.router.navigate([`/article-task/register/${articleTask.id}`]);
  }

}
